import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import * as autosuggestFilterActions from '~/actions/autosuggestFilter';
type AutosuggestFilterProps = {
  autosuggestFilterState: object;
  actions: object;
  options: any[];
  initialValue?: string;
  inputWidth?: string;
  placeholder?: string;
  suggestionsContainerMaxHeight?: number;
  onChange: (...args: any[]) => any;
  id: string;
};
class AutosuggestFilter extends React.Component<AutosuggestFilterProps, {}> {
  componentDidMount() {
    const { id, options, initialValue } = this.props;
    this.props.actions.updateAutosuggestSuggestions(id, options);
    this.props.actions.updateAutosuggestValue(id, initialValue);
  }
  onSuggestionsFetchRequested = ({ value }) => {
    const { id } = this.props;
    this.props.actions.updateAutosuggestSuggestions(id, this.getSuggestions(value));
  };
  onSuggestionsClearRequested = () => {
    const { id, options } = this.props;
    this.props.actions.updateAutosuggestSuggestions(id, options);
  };
  getSuggestionValue = suggestion => {
    return (suggestion && suggestion.value) || '';
  };
  renderSuggestion = (suggestion, { query }) => {
    if (!suggestion) {
      return;
    }
    const suggestionText = `${suggestion.value}`;
    const matches = match(suggestionText, query);
    const parts = parse(suggestionText, matches);
    return (
      <span>
        {parts.map((part, index) => {
          const className = part.highlight ? 'text--bold' : null;
          return (
            <span className={className} key={index}>
              {part.text}
            </span>
          );
        })}
      </span>
    );
  };
  onChange = (event, { newValue }) => {
    const { id } = this.props;
    this.props.actions.updateAutosuggestValue(id, newValue);
    this.props.onChange(newValue);
  };
  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  getSuggestions = value => {
    const { options } = this.props;
    const escapedValue = this.escapeRegexCharacters(value.trim());
    if (escapedValue === '') {
      return options;
    }
    const regex = new RegExp(escapedValue, 'i');
    return options.filter(option => regex.test(option.value));
  };
  render() {
    const {
      autosuggestFilterState = {},
      id,
      inputWidth = '100%',
      suggestionsContainerMaxHeight = 300,
      placeholder,
    } = this.props;
    const { [id]: autosuggestData = {} } = autosuggestFilterState;
    const { value = '', suggestions = [] } = autosuggestData;
    const theme = {
      container: {
        position: 'relative',
      },
      input: {
        width: inputWidth,
        height: 36,
        padding: '10px',
        border: '1px solid',
        borderColor: '#ccc',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
      },
      inputFocused: {
        outline: 'none',
      },
      inputOpen: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      suggestionsContainer: {
        display: 'none',
      },
      suggestionsContainerOpen: {
        display: 'block',
        position: 'absolute',
        top: 35,
        width: inputWidth,
        maxHeight: suggestionsContainerMaxHeight,
        border: '1px solid #e2e3e4',
        backgroundColor: '#fff',
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        zIndex: 2,
        overflow: 'auto',
      },
      suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
      },
      suggestion: {
        cursor: 'pointer',
        padding: '10px',
      },
      suggestionHighlighted: {
        backgroundColor: '#ddd',
      },
    };
    const inputProps = {
      placeholder: placeholder,
      value,
      onChange: this.onChange,
    };
    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          shouldRenderSuggestions={() => {
            return true;
          }}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          theme={theme}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    autosuggestFilterState: state.autosuggestFilterState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(autosuggestFilterActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutosuggestFilter);
